import React from 'react';

//MUI
import { Box, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


const Assurance = () => {
	return (
		<Box>
			<Box px={4} mt={6} mb={4}>
				<Typography className='heading' sx={{ color: "#e31837", fontSize: "28px", fontWeight: "900" }}>
					Independent Assurance Statement
				</Typography>
			</Box>
			<Box px={4} sx={{ textAlign: 'justify' }}>
				<Box mt={2} mb={4}>
					<Typography mb={2} variant='body1' sx={{ fontWeight: 'bold' }}>
						To, <br />
						The Board of Directors, <br />
						Mahindra & Mahindra Limited. <br />
						Mumbai, India <br />
					</Typography>
					<Typography>
						Mahindra & Mahindra Limited (Corporate Identity Number L65990MH1945PLC004558, hereafter referred to as ‘M&M Ltd or ‘the Company’) has commissioned DNV Business Assurance India Private Limited (‘DNV’, ‘us’ or ‘we’) to undertake an independent assurance of the Company’s disclosures in its Business Responsibility and Sustainability Report (hereafter referred to as ‘BRSR’). The disclosures include BRSR Core as per Annexure 17A of SEBI’s Master Circular for BRSR (Master Circular No. HO/49/14/14(7)2025-CFD-POD2/I/3762/2026, dated January 30, 2026).
					</Typography>
				</Box>
				<Box mt={2} mb={4}>
					<Typography mb={1} variant='body1' sx={{ fontWeight: 'bold', color: "#e31837", fontSize: "18px" }}>
						Scope of Work and Boundary
					</Typography>
					<Typography mb={4} variant='body1'>
						The scope of our engagement includes independent assurance of ‘BRSR Core’ – Reasonable level of assurance for Financial Year (FY) 2025-26.
						<br /><br />
						Boundary for the assessment covers the performance of M&amp;M Ltd’s operations in India that fall under the direct operational control of the Company’s Legal structure. Based on the agreed scope with the Company, the boundary of reasonable assurance covers the operations of M&amp;M Ltd across all locations in India for BRSR core attributes 5-9. For BRSR core attributes 1-4, the boundary is 27 manufacturing plants located India, 1 corporate office &amp; 13 area offices.
					</Typography>
				</Box>

				<Box mt={2} mb={4}>
					<Typography mb={1} variant='body1' sx={{ fontWeight: 'bold', color: "#e31837", fontSize: "18px" }}>
						Reporting Criteria and Standards
					</Typography>
					<Typography mb={4} variant='body1'>
						The disclosures have been prepared by M&amp;M Ltd in reference to:
						<ul>
							<li>Industry Standard on Reporting of BRSR Core, Circular No.: SEBI/HO/CFD/CFD PoD-1/P/CIR/2024/177 dated Dec 20, 2024.</li>
							<li>BRSR Core (Annexure 17A) as per Master Circular No. HO/49/14/14(7)2025-CFD POD2/I/3762/2026, “Master circular for compliance with the provisions of the Securities and Exchange Board of India (Listing Obligations and Disclosure Requirements) Regulations, 2015 by listed entities”, dated January 30, 2026.</li>
							<li>Greenhouse Gas Protocol: A Corporate Accounting and Reporting Standard.</li>
						</ul>
					</Typography>
				</Box>

				<Box mt={2} mb={4}>
					<Typography mb={1} variant='body1' sx={{ fontWeight: 'bold', color: "#e31837", fontSize: "18px" }}>
						Assurance Methodology/Standard and Level of Assurance
					</Typography>
					<Typography mb={4} variant='body1'>
						This assurance engagement has been carried out in accordance with DNV’s VeriSustainTM protocol, V6.0, which is based on our professional experience and international assurance practice, and the international standard in Assurance Engagements, ISAE 3000 (revised) - Assurance Engagements other than Audits or Reviews of Historical Financial Information. DNV’s VeriSustainTM Protocol, V6.0 has been developed in accordance with the most widely accepted reporting and assurance standards.
						<br /><br />
						Apart from DNV’s VeriSustainTM protocol (V6.0), DNV team has also followed ISO 14064-3 - Specification with guidance for the verification and validation of greenhouse gas statements to evaluate disclosures wrt. Greenhouse gases.
					</Typography>
				</Box>

				<Box mt={2} mb={4}>
					<Typography mb={1} variant='body1' sx={{ fontWeight: 'bold', color: "#e31837", fontSize: "18px" }}>
						Basis of our conclusion
					</Typography>
					<Typography mb={4} variant='body1'>
						As part of our independent assurance engagement, we have evaluated the reported environmental, social, and governance (ESG) information against the agreed criteria. Throughout the engagement, we exercised rigorous professional judgment and maintained a high level of professional skepticism to ensure the integrity and reliability of our conclusions.
						<br /><br />
						As part of the assurance process, a multi-disciplinary team of assurance specialists performed assurance work for selected sites of M&amp;M Ltd. We carried out the following activities:
						<ul>
							<li>Reviewed the disclosures under BRSR Core, encompassing the framework for assurance consisting of a set of Key Performance Indicators (KPIs) under 9 ESG attributes. The Industry Standard on Reporting of BRSR Core used a basis of reasonable level of assurance.</li>
							<li>Evaluation of the design and implementation of key systems, processes and controls for collecting, managing and reporting the BRSR Core indicators. Assessment of operational control and reporting boundaries.</li>
							<li>Seek extensive evidence across all relevant areas, ensuring a detailed examination of BRSR Core indicators. Engaged directly with stakeholders to gather insights and corroborative evidence for each disclosed indicator.</li>
							<li>DNV audit team conducted on-site audits for data testing and to assess the uniformity in reporting processes and, quality checks at different locations of the Company. Sites for data testing and reporting system checks were selected based on the percentage contribution each site makes to the reported indicator, complexity of operations at each location (high/low/medium) and reporting system within the organization. Sites selected for audits are listed in Annexure II.</li>
							<li>Interviews with selected senior managers responsible for management of disclosures and review of selected evidence to support environmental KPIs and metrics disclosed the Report. We were free to choose interviewees and interviewed those with overall responsibility of monitoring, data collation and reporting the selected indicators.</li>
							<li>Verification of the consolidated reported performance disclosures in context to the Principle of Completeness as per VeriSustainTM Protocol, V6.0 for reasonable level of assurance for the disclosures.</li>
						</ul>
					</Typography>
				</Box>

				<Box mt={2} mb={4}>
					<Typography mb={1} variant='body1' sx={{ fontWeight: 'bold', color: "#e31837", fontSize: "18px" }}>
						Inherent Limitations
					</Typography>
					<Typography mb={4} variant='body1'>
						DNV’s assurance engagement assume that the data and information provided by the Company to us as part of our review have been provided in good faith, is true, complete, sufficient, and authentic, and is free from material misstatements. The assurance scope has the following limitations:
						<ul>
							<li>The assurance engagement considers an uncertainty of ±5% based on materiality threshold for estimation/measurement errors and omissions.</li>
							<li>DNV has not been involved in evaluation or assessment of any financial data/performance of the Company. DNV opinion on specific BRSR Core indicators (for total revenue from operations; Principle 3, Question 1(c) of Essential Indicators for Spending on measures towards well-being of employees and workers – cost incurred as a % of total revenue of the Company; Principle 8, Question 4 of Essential Indicators, Principle 1, Question 8 of Essential Indicators and Principle 1, Question 9 of Essential Indicators) relies on the third party audited financial reports of the Company. DNV does not take any responsibility of the financial data reported in the audited financial reports of the Company.</li>
							<li>The assessment is limited to data and information within the defined Reporting Period. Any data outside this period is not considered within the scope of assurance.</li>
							<li>Data outside the operations specified in the assurance boundary is excluded from the assurance, unless explicitly mentioned otherwise in this statement.</li>
							<li>The assurance does not cover the Company's statements that express opinions, claims, beliefs, aspirations, expectations, aims, or future intentions. Additionally, assertions related to Intellectual Property Rights and other competitive issues are beyond the scope of this assurance.</li>
							<li>The assessment does not include a review of the Company's strategy or other related linkages expressed in the Report. These aspects are not within the scope of the assurance engagement.</li>
							<li>The assurance does not extend to mapping the Report with reporting frameworks other than those specifically mentioned. Any assessments or comparisons with frameworks beyond the specified ones are not considered in this engagement.</li>
							<li>Aspects of the Report that fall outside the mentioned scope and boundary are not subject to assurance. The assessment is limited to the defined parameters.</li>
							<li>The assurance engagement does not include a review of legal compliances. Compliance with legal requirements is not within the scope of this assurance, and the Company is responsible for ensuring adherence to relevant laws.</li>
						</ul>
					</Typography>
				</Box>

				<Box mt={2} mb={4}>
					<Typography mb={1} variant='body1' sx={{ fontWeight: 'bold', color: "#e31837", fontSize: "18px" }}>
						Responsibility of the Company
					</Typography>
					<Typography mb={4} variant='body1'>
						M&amp;M Ltd has the sole responsibility for the preparation of the BRSR and is responsible for all information disclosed in the BRSR Core attributes. The Company is responsible for maintaining processes and procedures for collecting, analyzing and reporting the information and also, ensuring the quality and consistency of the information presented in the Report. M&amp;M Ltd is also responsible for ensuring the maintenance and integrity of its website and any referenced BRSR disclosures on their website.
					</Typography>
				</Box>

				<Box mt={2} mb={4}>
					<Typography mb={1} variant='body1' sx={{ fontWeight: 'bold', color: "#e31837", fontSize: "18px" }}>
						DNV's Responsibility
					</Typography>
					<Typography mb={4} variant='body1'>
						In performing this assurance work, DNV’s responsibility is to the Management of the Company; however, this statement represents our independent opinion and is intended to inform the outcome of the assurance to the stakeholders of the Company. DNV disclaims any liability or co-responsibility for any decision a person or entity would make based on this assurance statement.
					</Typography>
				</Box>

				<Box mt={2} mb={4}>
					<Typography mb={4} variant='body1'>
						For DNV Business Assurance India Private Limited,
						<br /><br />

						<Box sx={{ display: 'flex', textAlign: 'left' }}>
							<Typography>
								<strong>Jas Sahib Singh Chadha</strong> <br />
								Lead Verifier
							</Typography>
							<Typography ml={{ xs: 4, sm: 5, md: 10 }}>
								<strong>Anjana Sharma</strong> <br />
								Assurance Reviewer
							</Typography>
						</Box>

						<br />

						<strong>Assurance Team:</strong> <br />
						Ankita Parab <br />
						Chandan Sarkar <br />
						Suraiya Rahman <br />
						Sudharshan K <br />
						Varsha Bohiya

						<br /><br />

						20/06/2026, Bengaluru, India.

						<br /><br />
					</Typography>
				</Box>
			</Box>

			<Box px={4} mt={7} mb={3}>
				<Typography className='heading' align='center' variant='h4' sx={{ color: "#e31837", fontSize: "22px", fontWeight: "900" }}>ANNEXURE I</Typography>
				<Typography mt={1} variant='body1' align='center' sx={{ fontWeight: 'bold' }}>BRSR Core Verified Data - for reasonable level of assurance</Typography>
			</Box>
			<Box px={4} mb={4}>
				<TableContainer component={Paper} m>
					<Table sx={{ minWidth: 1000 }} size="small">
						<TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
							<TableRow sx={{ backgroundColor: "#4d4d4f" }}>
								<TableCell sx={{ border: "1px solid #C3C4BD", width: '5%' }}><strong>Sr. No.</strong></TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD", width: '20%' }}><strong>Attribute</strong></TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD", width: '30%' }}><strong>BRSR Core Parameter</strong></TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD", width: '25%' }}><strong>Unit</strong></TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD", width: '20%' }}><strong>Verified Value for FY 2025-26</strong></TableCell>
							</TableRow>
						</TableHead>
						<TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={7}>1</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={7}>Green-house gas (GHG) footprint - Greenhouse gas emissions may be measured in accordance with the Greenhouse Gas Protocol: A Corporate Accounting and Reporting Standard *</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Total Scope 1 emissions</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT of CO2e</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>80,319</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Total Scope 2 emissions (market-based)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT of CO2e</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>2,41,210</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Total Scope 1 and Scope 2 emission intensity per rupee of turnover</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT of CO2e / Revenue from operations in ₹ Cr.</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>2.21</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Total Scope 1 and Scope 2 emission intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT of CO2e / Revenue from operations in ₹ Cr. adjusted for PPP</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>44.92</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={3}>Total Scope 1 and Scope 2 emission intensity in terms of physical output</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT of CO2e / Equivalent vehicles (Automotive Sector)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>0.089</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT of CO2e / Equivalent number of tractors manufactured (Farm Sector)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>0.073</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT of CO2e / Tonnes of packaging (Spares Business Unit)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>0.102</TableCell>
							</TableRow>

							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={7}>2</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={7}>Water footprint</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Total water consumption</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>KL</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>30,50,611</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={2}>Water consumption intensity</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>KL / Revenue from operations in ₹ Cr.</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>20.96</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>KL / Revenue from operations in ₹ Cr. adjusted for PPP</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>426.23</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={3}>Water intensity in terms of physical output</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>KL / Equivalent vehicles (Automotive Sector)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>0.917</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>KL / Equivalent number of tractors manufactured (Farm Sector)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>0.641</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>KL / Tons of packaging (Spares Business Units)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>3.375</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Water Discharge by destination and levels of Treatment</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>KL</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>0</TableCell>
							</TableRow>

							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={7}>3</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={7}>Energy footprint</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Total energy consumed</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Giga Joules (GJ)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>32,94,221</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>% of energy consumed from renewable sources</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>In % terms</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>19.77%</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={5}>Energy intensity</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>GJ / Revenue from operations in ₹ Cr.</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>22.63</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>GJ / Revenue from operations in ₹ Cr. adjusted for PPP</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>460.27</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>GJ / Equivalent vehicles (Automotive Sector)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>1.036</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>GJ / Equivalent number of tractors manufactured (Farm Sector)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>1.042</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>GJ / Tons of packaging (Spares Business Units)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>1.038</TableCell>
							</TableRow>

							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={33}>4</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={33}>Embracing circularity - details related to waste management by the entity</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Plastic waste (A)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>9,321</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>E-waste (B)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>482</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Bio-medical waste (C)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>0.35</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Construction and demolition waste (D)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>455</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Battery waste (E)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>433</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Radioactive waste (F)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>0.00</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={3}>Hazardous waste (G):</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Paint sludge</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>2,491</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Phosphate sludge</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>395</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>ETP sludge</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>1,513</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Other (Used oil, oil-soaked waste, grinding mud, hazardous waste containers etc.)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>8,296</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={3}>Non-hazardous waste (H):</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Foundry sand</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>70,417</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Metal scrap (Aluminum, MS, Copper, Steel, etc.)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>85,806</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Other (Cardboard, wood, food waste, etc.)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>32,503</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Total (A+B + C + D + E + F + G+ H)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>2,12,113</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Waste intensity per rupee of turnover from operations</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT / Revenue from operations in ₹ Cr.</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>1.46</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Waste intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT / Revenue from operations in ₹ Cr. adjusted for PPP</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>29.64</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={3}>Waste intensity</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Total waste generated in MT / Equivalent vehicles (Automotive Sector)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>0.061</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Total waste generated in MT / Equivalent number of tractors manufactured (Farm Sector)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>0.101</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Total waste generated in MT / Tons of packaging (Spares Business Units)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>0.219</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={3}>Total waste recovered through recycling, re-using or other recovery operations</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>(i) Recycled</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>1,34,946</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>(ii) Re-used</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>53,575</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>(iii) Other recovery operations</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>2,584</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Total</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>1,91,105</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Intensity (Waste Recycled Recovered / Total Waste generated)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>%</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>90.10%</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} colSpan={3}>Total waste disposed by nature of disposal method</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>(i) Incineration</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>2,582</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>(ii) Landfilling</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>18,426</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>(iii) Other disposal operations</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>0.00</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Total</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>MT</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>21,008</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Intensity (Waste Disposed / Total Waste generated)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>%</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>9.90%</TableCell>
							</TableRow>

							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={5}>5</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={5}>Enhancing Employee Wellbeing and Safety</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Spending on measures towards well-being of employees and workers – cost incurred as a % of total revenue of the company</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>In % terms</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>0.51%</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={4}>Details of safety related incidents for employees and workers (including contract-workforce e.g. workers in the company's construction sites)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Number of Permanent Disabilities</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>
									Employees – 0 <br />
									Workers – 0
								</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Total recordable work-related injuries</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>
									Employees – 0 <br />
									Workers – 6
								</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Lost Time Injury Frequency Rate (LTIFR) (per one million-person hours worked)</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>
									Employees – 0 <br />
									Workers – 0.07
								</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>No. of fatalities</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>
									Employees – 0 <br />
									Workers – 0
								</TableCell>
							</TableRow>

							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={4}>6</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={4}>Enabling Gender Diversity in Business</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Gross wages paid to females as % of wages paid</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>In % terms</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>8.46%</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={3}>Complaints on POSH</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Total Complaints on Sexual Harassment (POSH) reported</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>29</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Complaints on POSH as a % of female employees / workers</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>0.27%</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Complaints on POSH upheld</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>16</TableCell>
							</TableRow>

							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={7}>7</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={7}>Enabling Inclusive Development</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={2}>Input material sourced from following sources as % of total purchases and from within India</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Directly sourced from MSMEs/ small producers</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>9.7%</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Directly sourced from within India</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>90.4%</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={5}>Job creation in smaller towns – Wages paid to persons employed in smaller towns (permanent or non-permanent /on contract) as % of total wage cost</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Location</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}></TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Rural</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>0.7%</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Semi-urban</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>14.8%</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Urban</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>9.7%</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Metropolitan</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>74.8%</TableCell>
							</TableRow>

							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={2}>8</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={2}>Fairness in Engaging with Customers and Suppliers</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Instances involving loss / breach of data of customers as a percentage of total data breaches or cyber security events</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>In % terms</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Nil</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Number of days of accounts payable</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>(Accounts payable *365) / Cost of goods/services procured</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>81</TableCell>
							</TableRow>

							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={11}>9</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={11}>Open-ness of business</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={6}>Concentration of purchases &amp; sales done with trading houses, dealers, and related parties Loans and advances &amp; investments with related parties</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Purchases from trading houses as % of total purchases</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>0.07%</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Number of trading houses where purchases are made from</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>20</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Purchases from top 10 trading houses as % of total purchases from trading houses</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>95.7%</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Sales to dealers / distributors as % of total sales</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>96.2%</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Number of dealers / distributors to whom sales are made</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>4,480</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Sales to top 10 dealers / distributors as % of total sales to dealers / distributors</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>13.9%</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }} rowSpan={5}></TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Share of RPTs (as respective %age) in</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}></TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Purchases</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>9.8%</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Sales</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>13.2%</TableCell>
							</TableRow>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Loans &amp; advances</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>108%</TableCell>
							</TableRow>
							<TableRow>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>Investments</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>16.7%</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</TableContainer>
				<Typography mt={2} variant='body2' align='justify'>
					Note: * Calculation of Scope 1 GHG emissions are based on conversion factors, emission factors considered in 2006 IPCC Guidelines for National Greenhouse Gas Inventories and IPCC sixth assessment report. Scope 2 GHG emissions for India operations are calculated based on emission factors in Central Electricity Authority, Govt. of India (CEA Version_21.0) which is 0.710 tCO2 per MWh.
				</Typography>
			</Box>
			<Box px={4} mt={7} mb={3}>
				<Typography className='heading' align='center' variant='h4' sx={{ color: "#e31837", fontSize: "22px", fontWeight: "900" }}>
					ANNEXURE II
				</Typography>
				<Typography mt={1} variant='body1' align='center' sx={{ fontWeight: 'bold' }}>
					Sites selected for audits
				</Typography>
			</Box>

			<Box px={4} mb={5}>
				<TableContainer component={Paper} m>
					<Table sx={{ minWidth: 650 }} size="small">
						<TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
							<TableRow sx={{ backgroundColor: "#4d4d4f" }}>
								<TableCell sx={{ border: "1px solid #C3C4BD", width: '8%' }}>
									<strong>S.no</strong>
								</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD", width: '27%' }}>
									<strong>Site</strong>
								</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD", width: '65%' }}>
									<strong>Location</strong>
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
							<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>
									1.
								</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>
									Corporate Office
								</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>
									Mumbai, Maharashtra
								</TableCell>
							</TableRow>

							<TableRow>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>
									2.
								</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>
									Manufacturing Plants (on-site)
								</TableCell>
								<TableCell sx={{ border: "1px solid #C3C4BD" }}>
									Kandivali, Maharashtra; Igatpuri, Maharashtra; Nashik, Maharashtra - Automotive Sector <br />
									Kandivali, Maharashtra; Nagpur, Maharashtra - Farm Division <br />
									Swaraj Plant 1 &amp; 2, Mohali, Punjab - Swaraj Division <br />
									Kanhe, Maharashtra - Spares Business Unit <br />
									Tamil Nadu, Chennai - Mahindra Research Valley
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</TableContainer>
			</Box>
		</Box>
	)
}

export default Assurance;